var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.4C14.3667 13.4 13.8 13.65 13.3667 14.0417L7.425 10.5834C7.46667 10.3917 7.5 10.2 7.5 10C7.5 9.80002 7.46667 9.60835 7.425 9.41669L13.3 5.99169C13.75 6.40835 14.3417 6.66669 15 6.66669C16.3833 6.66669 17.5 5.55002 17.5 4.16669C17.5 2.78335 16.3833 1.66669 15 1.66669C13.6167 1.66669 12.5 2.78335 12.5 4.16669C12.5 4.36669 12.5333 4.55835 12.575 4.75002L6.7 8.17502C6.25 7.75835 5.65833 7.50002 5 7.50002C3.61667 7.50002 2.5 8.61669 2.5 10C2.5 11.3834 3.61667 12.5 5 12.5C5.65833 12.5 6.25 12.2417 6.7 11.825L12.6333 15.2917C12.5917 15.4667 12.5667 15.65 12.5667 15.8334C12.5667 17.175 13.6583 18.2667 15 18.2667C16.3417 18.2667 17.4333 17.175 17.4333 15.8334C17.4333 14.4917 16.3417 13.4 15 13.4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFilled);
export default __webpack_public_path__ + "static/media/shareFilled.a72714f3b9672a0554b545677f20af13.svg";
export { ForwardRef as ReactComponent };